import Header from '@app/components/Header'
import QuickAddModal from '@app/components/QuickAddModal'
import ShareAttachmentModal from '@app/components/ShareAttachmentModal'
import Sidebar from '@app/components/Sidebar'
import * as GlobalState from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import * as Scroll from 'react-scroll'
import { Button } from 'reactstrap'
import * as ReactiveLayoutStore from '../modules/ReactiveLayout'
import './ReactiveLayout.css'

type LayoutProps = ReactiveLayoutStore.IReactiveLayoutState &
  typeof ReactiveLayoutStore.actionCreators &
  typeof GlobalState.actionCreators

interface IComponentState {
  scrollTop: number
}

const scroll = Scroll.animateScroll

export default class ReactiveLayout extends React.Component<
  LayoutProps,
  IComponentState
> {
  private headerRef: React.RefObject<HTMLDivElement>
  private sidebarRef: React.RefObject<HTMLDivElement>

  constructor(props: LayoutProps) {
    super(props)
    this.headerRef = React.createRef()
    this.sidebarRef = React.createRef()

    bindFunctions(this)

    this.state = {
      scrollTop: 0,
    }
  }

  public componentDidMount() {
    const headerHeight =
      this.headerRef && this.headerRef.current
        ? this.headerRef.current.clientHeight
        : 60
    const sidebarWidth =
      this.sidebarRef && this.sidebarRef.current
        ? this.sidebarRef.current.children[0].clientWidth
        : 300

    this.props.initializeLayout(
      headerHeight,
      sidebarWidth,
      -sidebarWidth,
      true,
    )
  }

  public componentWillMount() {
    this.windowResize()
    window.addEventListener('resize', this.windowResize.bind(this))
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.windowResize.bind(this))
  }

  public windowResize() {
    if (window.innerWidth > 991) {
      this.props.setTouchEnabled(false)
    } else {
      this.props.setTouchEnabled(true)
    }
  }

  public render() {
    let height = 60
    if (this.headerRef.current) {
      height = this.headerRef.current.clientHeight
    }

    const sidebarStyle: React.CSSProperties = {
      left: this.props.tx,
      marginTop: this.props.touchEnabled ? height : 0,
      transitionDuration: this.props.panning ? '0s' : '0.25s',
      visibility: this.props.sidebarReady ? 'visible' : 'hidden',
    }

    const contentStyle: React.CSSProperties = {
      flexGrow: 1,
      position: 'relative',
    }

    return (
      <div
        onTouchEnd={(e: any) => this.props.touchEnd(e.touches[0])}
        onTouchStart={(e: any) => this.props.touchStart(e.touches[0])}
        onTouchMove={(e: any) => this.props.touchMove(e.touches[0])}
        className='RLContainer'
      >
        <div className='RLPageContainer d-flex flex-row justify-content-between'>
          <div
            id='sidebarContainer'
            style={sidebarStyle}
            className='RLSidebarContainer'
            ref={this.sidebarRef}
          >
            {/* @ts-expect-error - Sidebar component props type mismatch with closeSidebar prop */}
            <Sidebar closeSidebar={this.props.toggleSidebar} />
          </div>
          <div
            id='headerContainer'
            className='RLMainContentContainer'
            style={contentStyle}
          >
            <div ref={this.headerRef}>
              {/* @ts-expect-error - Header component props type mismatch with toggleClick prop */}
              <Header toggleClick={this.props.toggleSidebar} />
            </div>
            {this.renderScrollToTop()}
            <div
              id='contentContainer'
              className='RLContentContainer'
              onScroll={this._handleScroll}
            >
              {this.props.children}
              <ShareAttachmentModal />
              <QuickAddModal />
            </div>
          </div>
        </div>
      </div>
    )
  }

  private _handleScroll(e: any) {
    // the calculation below is a Q&D way to "turn off" the go to top button on edit pages
    // since the child container is absolutely positioned
    this.setState({
      scrollTop:
        e.target.children[0] && e.target.children[0].autocomplete === 'off'
          ? 0
          : e.target.scrollTop,
    })
  }

  private renderScrollToTop() {
    const classNames = `mr-4 float-right back-to-top ${
      this.state.scrollTop > 200 ? 'show' : ''
    }`

    return (
      <Button
        color='primary'
        className={classNames}
        style={{ zIndex: 1000 }}
        onClick={(e) => {
          scroll.scrollToTop({
            containerId: 'contentContainer',
            isDynamic: true,
          })
          this.setState({
            scrollTop: 0,
          })
        }}
      >
        <FontAwesomeIcon icon={['fas', 'arrow-alt-up']} className='mr-2' />
        Go to top
      </Button>
    )
  }
}
